import { render, staticRenderFns } from "./PaginatedMessagesDialog.vue?vue&type=template&id=216b4aec&scoped=true&"
import script from "./PaginatedMessagesDialog.vue?vue&type=script&lang=js&"
export * from "./PaginatedMessagesDialog.vue?vue&type=script&lang=js&"
import style0 from "./PaginatedMessagesDialog.vue?vue&type=style&index=0&id=216b4aec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216b4aec",
  null
  
)

export default component.exports